import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { MaskitoDirective } from '@maskito/angular';

import { ErrorMessageDirective } from '../../directives/error-message.directive';
import { RequiredDirective } from '../../directives/required.directive';
import { MiscModule } from '../../misc.module';
import { CustomerInformationComponent } from './components/customer-information/customer-information.component';
import { MiscItemsComponent } from './components/misc-items/misc-items.component';
import { MortgageComponent } from './components/mortgage/mortgage.component';
import { SalesCommissionComponent } from './components/sales-commission/sales-commission.component';
import { TaxesComponent } from './components/taxes/taxes.component';
import { TransactionInformationComponent } from './components/transaction-information/transaction-information.component';
import { UserInformationComponent } from './components/user-information/user-information.component';
import { NetSheetPageRoutingModule } from './net-sheet-routing.module';
import { NetSheetPageComponent } from './net-sheet.page';

@NgModule({
  declarations: [
    NetSheetPageComponent,
    MortgageComponent,
    SalesCommissionComponent,
    UserInformationComponent,
    TaxesComponent,
    TransactionInformationComponent,
    MiscItemsComponent,
    CustomerInformationComponent
  ],
  imports: [
    CommonModule,
    NetSheetPageRoutingModule,
    IonicModule,
    MiscModule,
    ReactiveFormsModule,
    MaskitoDirective,
    ErrorMessageDirective,
    RequiredDirective
  ]
})
export class NetSheetPageModule {}
